import Table, { TableData } from "PFComponents/table/table";
import { GenerateColumnsFn } from "PFComponents/table/table.types";
import { PaginatedCollection } from "PFTypes";

import css from "./import_data_table_page.module.scss";

const COUNTERS_SIZE = 73;
const PAGINATION_SIZE = 38;

type ImportDataTableProps<TABLE_DATA extends TableData> = {
  rowsData: PaginatedCollection<TABLE_DATA[]>;
  currentPage: number;
  setCurrentPage: (page: number) => void;
  generateColumns: GenerateColumnsFn<TABLE_DATA>;
};

export const ImportDataTable = <TABLE_DATA extends TableData>({
  rowsData,
  currentPage,
  setCurrentPage,
  generateColumns
}: ImportDataTableProps<TABLE_DATA>) => (
  <Table<TABLE_DATA>
    tableData={rowsData.entries || []}
    generateColumns={generateColumns}
    paginationOptions={{
      totalPages: rowsData?.meta.totalPages || 1,
      currentPage,
      onClick: setCurrentPage,
      className: css.tablePagination
    }}
    bottomElementsSize={COUNTERS_SIZE + PAGINATION_SIZE}
  />
);
